








import { Component, Vue } from 'vue-property-decorator'
import { isPlatformAndroid } from '@/utils/cordova'
import URLScheme from '@/utils/urlScheme'

@Component
export default class VideoHangup extends Vue {
  mounted() {
    if (isPlatformAndroid()) this.close()
  }
  close() {
    window.location.href = URLScheme.closeCallview
  }
}
